import React from "react";
import PropTypes from "prop-types";

const Card = ({ title, pageUrl, image, video, videoThumbnail }) => {
  const source = video && videoThumbnail ? videoThumbnail : image;

  return (
    <div className="related-list__card">
      <a className="related-list__link" href={pageUrl}>
        {source != null && source.length > 0 ? <img src={source} className="cardImg" alt={title} loading="lazy" /> : null}
        <h5 className="related-list__card-title">{title}</h5>
      </a>
    </div>
  );
};

Card.propTypes = {
  title: PropTypes.string,
  pageUrl: PropTypes.string,
  image: PropTypes.string,
  video: PropTypes.string,
  videoThumbnail: PropTypes.string
};

export default Card;
